'use strict';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _ = require('lodash');

var _require = require('./function'),
    memoize = _require.memoize;

var sampleMappingUtils = require('./sample-mapping');

var minWattHourThreshold = 10;

var hardwareUtils = require('./hardware');

var _require2 = require('./formatters'),
    useSignificantDigits = _require2.useSignificantDigits;

var registerIsMain = hardwareUtils.registerIsMain,
    registerIsConsumption = hardwareUtils.registerIsConsumption,
    otherRegister = hardwareUtils.otherRegister;

function getSnapshotWithMostData(snapshots) {
  var r = [];
  snapshots.forEach(function (s) {
    if (s.length > r.length) {
      r = s;
    }
  });
  return r;
}

function sumCircuitsWattage(registers) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'w';
  return useSignificantDigits(registers.filter(function (c) {
    return c;
  }).map(function (register) {
    return register[key];
  }).reduce(function (a, b) {
    return a + (b || 0);
  }, 0));
}

function absoluteValueConsumers(registers) {
  return registers.map(function (r) {
    Object.keys(r).forEach(function (key) {
      if (sampleMappingUtils.isNumericalProperty(key) && r[key] !== null && !isNaN(r[key]) && registerIsConsumption(r)) {
        r[key] = Math.abs(r[key]);
      }
    });
    return r;
  });
}

function applyThresholds(circuits) {
  return circuits.map(function (c) {
    Object.keys(c).forEach(function (key) {
      if (sampleMappingUtils.isWattageProperty(key) && !c.other) {
        var circuitValue = c[key]; // apply a threshold and give set a flag indicating it has been thresholded

        if (circuitValue !== null && !isNaN(circuitValue) && Math.abs(circuitValue) < minWattHourThreshold) {
          c[key] = 0; // c[`${key}_lo`] = true;
        }
      }
    });
    return c;
  });
}

function sumCircuitsWithSameName(circuits) {
  var findMatchingCircuit = function findMatchingCircuit(c, targetCircuit) {
    return c.label && targetCircuit.label && c.label.trim() === targetCircuit.label.trim() && c.circuit_type === targetCircuit.circuit_type && !c.other;
  }; // clone circuits, because we are going to transform them


  circuits = circuits.map(function (c) {
    return _objectSpread({}, c);
  });
  return circuits.reduce(function (acc, circuit) {
    var circuitsWithSameName = circuits.filter(function (c) {
      return findMatchingCircuit(c, circuit);
    });
    var preExistingCircuitWithSameName = acc.find(function (c) {
      return findMatchingCircuit(c, circuit);
    }); // a circuit with this name has already been aggregated, do nothing

    if (preExistingCircuitWithSameName) {
      return acc;
    } // if we have more than one circuit with the same name, merge them together


    if (circuitsWithSameName.length > 1) {
      // arbitrarily assign the circuit with the alphabetically highest ID as the base circuit
      var baseCircuit = circuitsWithSameName.sort(function (a, b) {
        return a.id > b.id ? 1 : -1;
      })[0]; // get all of the keys present in circuits with same name

      var circuitKeys = circuitsWithSameName.map(function (c) {
        return Object.keys(c);
      }).reduce(function (acc, v) {
        return acc.concat(v.filter(function (k) {
          return !acc.find(function (existingKey) {
            return existingKey === k;
          });
        }));
      }, []);
      circuitKeys.forEach(function (key) {
        if (sampleMappingUtils.isNumericalProperty(key)) {
          baseCircuit[key] = sumCircuitsWattage(circuitsWithSameName, key);
        }
      });
      acc.push(baseCircuit);
    } // no other circuit with the same name exists, so add it
    else {
      acc.push(circuit);
    }

    return acc;
  }, []);
} // absolute value, apply thresholds, sum circuits with same name


function postProcessSnapshot(snapshot, otherCircuitKeys, forceOther) {
  var partialFallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var numericalKeysPresent = snapshot.reduce(function (acc, v) {
    var registerKeys = Object.keys(v);
    return acc.concat(registerKeys.filter(function (key) {
      return sampleMappingUtils.numericalValueKeys.indexOf(key) > -1 && !acc.find(function (k) {
        return k === key;
      });
    }));
  }, []); // this is not for a temporal partial (i.e. a timestamp where we have data for one hub but not another)
  // this is for a register partial, a register which is missing numerical data for some reason

  snapshot = snapshot.map(function (register) {
    numericalKeysPresent.forEach(function (k) {
      if (typeof register[k] === 'undefined') {
        register[k] = partialFallback;
      }
    });
    return register;
  });

  if (snapshot.w) {
    snapshot.w = Math.round(snapshot.w);
  }

  snapshot = absoluteValueConsumers(snapshot);
  var other = addOther(snapshot, true);

  if (other) {
    if (!other.id && other.register) {
      other = _objectSpread(_objectSpread({}, other), {}, {
        register: undefined
      }, other.register);
    }

    snapshot.push(other);
  }

  snapshot = sumCircuitsWithSameName(snapshot);
  snapshot = applyThresholds(snapshot);
  return snapshot;
}

function addOther(channels) {
  if (!channels.length) {
    return;
  } // other already exists, exit


  if (channels.find(function (c) {
    return c.other || c.register && c.register.other;
  })) {
    return;
  }

  var other = {
    register: _objectSpread({}, otherRegister)
  };
  var registerMap = new Map();
  channels.forEach(function (c) {
    return registerMap.set(c, c.register ? c.register : c);
  });
  var mains = channels.filter(function (c) {
    return registerIsMain(registerMap.get(c));
  });

  if (mains.length) {
    var _channels$reduce = channels.reduce(function (acc, v) {
      var register = registerMap.get(v);
      var target = null;

      if (register) {
        if (registerIsConsumption(register) && !register.other) {
          target = acc[0];
        } else if (register.production && !register.grid) {
          target = acc[1];
        } else if (register.battery && !register.grid) {
          target = acc[2];
        }
      }

      if (target) {
        target.push(v);
      }

      return acc;
    }, [[], [], []]),
        _channels$reduce2 = _slicedToArray(_channels$reduce, 3),
        consumers = _channels$reduce2[0],
        breakerSideProducers = _channels$reduce2[1],
        breakerSideBattery = _channels$reduce2[2]; // extract any channel keys that may exist


    ['w', 'i', 'avg', 'kwh', 'kwhr', 'cost', 'cost_30d'].forEach(function (key) {
      if (!channels[0].hasOwnProperty(key)) {
        return;
      }

      other[key] = useSignificantDigits(Math.max(0, // total consumption
      sumCircuitsWattage(mains, key) - // consuming circuits
      sumCircuitsWattage(consumers, key) - ( // breaker-side production circuits
      sumCircuitsWattage(breakerSideProducers, key) + // breaker-side battery
      sumCircuitsWattage(breakerSideBattery, key))));
    });
    return other;
  }
}
/*
returns an array of child arrays, where the child arrays contain all of the snapshot registers
that belong to a particular phase, where the index of the child array is the phase index
if a register belongs to multiple phases, a copy is added to each, and their wattage/kwh values
are divided evenly amongst the number of phases 
[
  [{},{},{},{},{},{},{},{},{}],
  [{},{},{},{},{},{},{},{},{}]
]
*/


function splitSnapshotIntoPhaseComponents(snapshot, getPhasesForRegister) {
  return snapshot.reduce(function (acc, r) {
    var _getPhasesForRegister = getPhasesForRegister(r),
        phases = _getPhasesForRegister.phases;

    var addToPhase = function addToPhase(register, phaseIndex) {
      acc[phaseIndex] = acc[phaseIndex] || [];
      var phaseGroup = acc[phaseIndex];
      var nums = {};
      sampleMappingUtils.numericalValueKeys.forEach(function (k) {
        if (!isNaN(register[k])) {
          nums[k] = register[k] / phases.length;
        }
      });
      phaseGroup.push(_objectSpread(_objectSpread({}, register), nums));
    };

    phases.forEach(function (phaseIndex) {
      return addToPhase(r, phaseIndex);
    });
    return acc;
  }, []);
}

;

function getGridImpactForSnapshot(snapshot) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$metric = _ref.metric,
      metric = _ref$metric === void 0 ? 'w' : _ref$metric,
      omitFallbackToNonGrid = _ref.omitFallbackToNonGrid;

  var gridSnapshot = snapshot.filter(function (r) {
    return r.grid;
  }); // if no grid registers are found, simply sum everything 

  if (!omitFallbackToNonGrid && !gridSnapshot.length) {
    gridSnapshot = snapshot;
  }

  return sumCircuitsWattage(gridSnapshot, metric);
}

function getConsumptionForSnapshot(snapshot) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$metric = _ref2.metric,
      metric = _ref2$metric === void 0 ? 'w' : _ref2$metric;

  var mains = snapshot.filter(registerIsMain); // with no mains, just sum consumers

  if (!mains.length) {
    return sumCircuitsWattage(snapshot.filter(registerIsConsumption), metric);
  } // return mains - breaker side producers


  return sumCircuitsWattage(mains, metric) - (sumCircuitsWattage( // breaker side solar
  snapshot.filter(function (register) {
    return register.production && !register.grid;
  }), metric) + sumCircuitsWattage(snapshot.filter(function (register) {
    return register.battery && !register.grid;
  }), metric));
}

function getProductionForSnapshot(snapshot) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref3$metric = _ref3.metric,
      metric = _ref3$metric === void 0 ? 'w' : _ref3$metric;

  return sumCircuitsWattage(snapshot.filter(hardwareUtils.registerIsProduction), metric);
}

function getBatteryForSnapshot(snapshot) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref4$metric = _ref4.metric,
      metric = _ref4$metric === void 0 ? 'w' : _ref4$metric;

  return sumCircuitsWattage(snapshot.filter(hardwareUtils.registerIsBattery), metric);
}

function getLatestSnapshot(live, locationId) {
  return live[locationId] ? live[locationId][0] : [];
}

function getGridImpactForFlatSample(flatSample) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref5$metric = _ref5.metric,
      metric = _ref5$metric === void 0 ? 'w' : _ref5$metric,
      omitFallbackToNonGrid = _ref5.omitFallbackToNonGrid;

  var gridRegisters = flatSample.c.filter(function (c) {
    return c.register.grid;
  }); // if no grid registers are found, simply sum everything 

  if (!omitFallbackToNonGrid && !gridRegisters.length) {
    gridRegisters = flatSample.c;
  }

  return sumCircuitsWattage(gridRegisters, metric);
}

function getConsumptionForFlatSample(flatSample) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref6$metric = _ref6.metric,
      metric = _ref6$metric === void 0 ? 'w' : _ref6$metric;

  var mains = flatSample.c.filter(function (c) {
    return registerIsMain(c.register);
  }); // with no mains, just sum consumers

  if (!mains.length) {
    return sumCircuitsWattage(flatSample.c.filter(function (c) {
      return registerIsConsumption(c.register);
    }), metric);
  } // return mains - breaker side producers


  return sumCircuitsWattage(mains, metric) - sumCircuitsWattage( // breaker side solar/battery
  flatSample.c.filter(function (_ref7) {
    var register = _ref7.register;
    return (register.production || register.battery) && !register.grid;
  }), metric);
}

function getProductionForFlatSample(flatSample) {
  var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref8$metric = _ref8.metric,
      metric = _ref8$metric === void 0 ? 'w' : _ref8$metric;

  return sumCircuitsWattage(flatSample.c.filter(function (_ref9) {
    var register = _ref9.register;
    return hardwareUtils.registerIsProduction(register);
  }), metric);
}

function getBatteryForFlatSample(flatSample) {
  var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref10$metric = _ref10.metric,
      metric = _ref10$metric === void 0 ? 'w' : _ref10$metric;

  return sumCircuitsWattage(flatSample.c.filter(function (_ref11) {
    var register = _ref11.register;
    return hardwareUtils.registerIsBattery(register);
  }), metric);
}

function sortCircuits(circuits, sortingKey) {
  sortingKey = typeof sortingKey !== 'string' ? 'label' : sortingKey;
  return circuits.sort(function (a, b) {
    if (a.total) return -1;
    if (b.total) return 1;
    if (registerIsMain(a)) return -1;
    if (registerIsMain(b)) return 1;
    if (a.production) return -1;
    if (b.production) return 1;
    if (a.other) return 1;
    if (b.other) return -1;

    if (sortingKey == 'label') {
      if (!a['label']) return 1;
      if (!b['label']) return -1;
    }

    return a[sortingKey] < b[sortingKey] ? -1 : 1;
  });
}
/* 
accepts an array of channels and does vector sum of real power and reactive power
to produce cumulative values for:
- realPower
- reactivePower
- phaseAngle
- apparentPower
*/


function getPowerAnalysis(channels) {
  var _channels$reduce3 = channels.reduce(function (acc, v) {
    acc = {
      realPower: acc.realPower + v.w,
      reactivePower: acc.reactivePower + v.var // realPower_abs: acc.realPower_abs + Math.abs(v.w),
      // reactivePower_abs: acc.reactivePower_abs + Math.abs(v.var)

    };
    return acc;
  }, {
    realPower: 0,
    // realPower_abs: 0,
    reactivePower: 0 // reactivePower_abs: 0

  }),
      realPower = _channels$reduce3.realPower,
      reactivePower = _channels$reduce3.reactivePower;

  var apparentPower = Math.sqrt(Math.pow(realPower, 2) + Math.pow(reactivePower, 2));
  var phaseAngle = Math.atan(reactivePower / realPower); // phaseAngle is NaN when reactivePower or realPower is 0

  if (isNaN(phaseAngle)) {
    phaseAngle = 0;
  } // SIGN MANIPULATION - TODO, is this necessary?
  // ensure apparent power and reactive power have the same sign as real power
  // const realPowerSign = realPower > 0 ? 1 : -1;
  // if((apparentPower > 0 ? 1 : -1) !== realPowerSign){
  //   apparentPower *= -1;
  // }
  // if((reactivePower > 0 ? 1 : -1) !== realPowerSign){
  //   reactivePower *= -1;
  // }
  // to calculate phase angle, use abs value of power and reactive power totals
  // const phaseAngle = Math.atan(reactivePower_abs/realPower_abs);


  return {
    realPower: realPower,
    reactivePower: reactivePower,
    phaseAngle: phaseAngle,
    powerFactor: Math.cos(phaseAngle),
    apparentPower: apparentPower
  };
}

module.exports = {
  getSnapshotWithMostData: getSnapshotWithMostData,
  sumReadingsFromChannels: sumCircuitsWattage,
  sumCircuitsWattage: sumCircuitsWattage,
  absoluteValueConsumers: absoluteValueConsumers,
  applyThresholds: applyThresholds,
  sumCircuitsWithSameName: sumCircuitsWithSameName,
  addOther: addOther,
  splitSnapshotIntoPhaseComponents: splitSnapshotIntoPhaseComponents,
  postProcessSnapshot: postProcessSnapshot,
  getGridImpactForSnapshot: getGridImpactForSnapshot,
  getConsumptionForSnapshot: getConsumptionForSnapshot,
  getProductionForSnapshot: getProductionForSnapshot,
  getBatteryForSnapshot: getBatteryForSnapshot,
  getLatestSnapshot: getLatestSnapshot,
  sortCircuits: sortCircuits,
  getPowerAnalysis: getPowerAnalysis,
  getGridImpactForFlatSample: getGridImpactForFlatSample,
  getConsumptionForFlatSample: getConsumptionForFlatSample,
  getProductionForFlatSample: getProductionForFlatSample,
  getBatteryForFlatSample: getBatteryForFlatSample
};